<template>
  <div class="page-world-comments">
    <world-map :comments="comments" :active-id="activeId" />
  </div>
</template>

<script>
import axios from 'axios'
import WorldMap from './_world-map.vue'

const mqttType = 'city-map'
const mqttTypeZoom = 'city-map-zoom'
const mqttTypeCancelZoom = 'city-map-cancel-zoom'

let idCounter = 0

export default {
  name: 'WorldComments',
  components: { WorldMap },
  computed: {
    activityId() {
      return this.$route.params.id
    },
    mqttTopic() {
      return 'cityMap/' + this.activityId
    }
  },
  data() {
    return {
      comments: [],
      activeId: null
    }
  },
  mounted() {
    this.fetchCityMapUsers()
    this.subscribeCityMap()
  },
  beforeDestroy() {
    this.unsubscribeCityMap()
  },
  methods: {
    async fetchCityMapUsers() {
      try {
        const list = await axios.get(
          'https://api-hk1.yololiv.com/overseas/livestream/cityMapUsers',
          { params: { activityId: this.activityId } }
        )

        if (list.length === 0) return
        //const list = res.data || []
        list.forEach((item) => {
          const lat = Number(item.latitude)
          const lng = Number(item.longitude)
          if (!lat || !lng) {
            console.warn('Invalid coordinates:', item)
            return
          }
          this.upsertComment({
            username: item.name,
            avatar: item.avatar,
            city: item.city,
            lat,
            lng
          })
        })
      } catch (e) {
        console.error('fetchCityMapUsers error:', e)
      }
    },
    subscribeCityMap() {
      this.$mqtt.on(this.mqttTopic, mqttType, this.onCityMapMessage)
      this.$mqtt.on(this.mqttTopic, mqttTypeZoom, this.onCityMapZoomMessage)
      this.$mqtt.on(this.mqttTopic, mqttTypeCancelZoom, this.onCityMapCancelZoom)
    },
    unsubscribeCityMap() {
      this.$mqtt.off(this.mqttTopic, mqttType, this.onCityMapMessage)
      this.$mqtt.off(this.mqttTopic, mqttTypeZoom, this.onCityMapZoomMessage)
      this.$mqtt.off(this.mqttTopic, mqttTypeCancelZoom, this.onCityMapCancelZoom)
    },
    parseMapMessage(data) {
      const { name, avatar, city, latitude, longitude } = JSON.parse(data).data
      const lat = Number(latitude)
      const lng = Number(longitude)
      if (!lat || !lng) return null
      return { username: name, avatar, city, lat, lng }
    },
    upsertComment(parsed) {
      // 1. 删除同用户的老数据（一个用户只能出现在一个城市）
      // 2. 删除同城市的老数据（一个城市只显示最新的用户）
      this.comments = this.comments.filter(c =>
        c.username !== parsed.username && (!parsed.city || c.city !== parsed.city)
      )
      const comment = { ...parsed, id: ++idCounter }
      this.comments.unshift(comment)
      return comment
    },
    onCityMapMessage(data) {
      const parsed = this.parseMapMessage(data)
      if (!parsed) return
      this.upsertComment(parsed)
    },
    onCityMapZoomMessage(data) {
      const parsed = this.parseMapMessage(data)
      if (!parsed) return
      const comment = this.upsertComment(parsed)
      this.flyTo(comment)
    },
    onCityMapCancelZoom() {
      this.activeId = null
    },
    flyTo(comment) {
      if (this.activeId !== null) {
        this.activeId = null
        this.$nextTick(() => {
          this.activeId = comment.id
        })
      } else {
        this.activeId = comment.id
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page-world-comments {
  height: 100vh;
  overflow: hidden;
}
</style>
